export const languageKey = 'wglang';

export const getWeglotLang = () => {
    return localStorage.getItem(languageKey);
};

export const updateUrlWithWeglotLang = (url, currentLang) => {
    try {
        if (!url || typeof url !== 'string') return url;

        // get current language
        const lang = currentLang || getWeglotLang();
        if (!lang || typeof lang !== 'string') return url;

        const paramName = 'lang';

        // find lang param
        const pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');

        // if so replace with current weglot lang value
        if (url.search(pattern) >= 0) {
            return url.replace(pattern, '$1' + lang + '$2');
        }

        return url;
    } catch (err) {
        console.error(err);
        return url;
    }
};



// WEBPACK FOOTER //
// ./src/utils/weglotStorageHelper.js